export const layerConstant = {
    GET_TREE: "GET_TREE",
    GET_TREE_SUCCESS: "GET_TREE_SUCCESS",
    GET_TREE_FAIL: "GET_TREE_FAIL",
    SET_SELECTED_NODE:'SET_SELECTED_NODE'

};

export default layerConstant;